import {
  CarConditionEntryItemType,
  DamageMapItemType,
} from '../../../../types/bodyAndPaint';
import { DamageCheckMap } from '../util/common/damageCheckMap';
import { EntryField } from '../util/common/entryField';
import { ListItemPicker } from '../util/listSelectField';
import { RadioGroup } from '../util/radioGroup';
import { TextAreaField } from '../util/textFIeld';

interface EntryCarConditionField {
  state: CarConditionEntryItemType;
  setState: {
    isDrivenSelect: (select: number) => void;
    damageMapCheck: (key: keyof DamageMapItemType) => void;
    damageDegreeSelect: (select: number) => void;
    otherPartSelect: (select: number) => void;
    noticeDateText: (text: string) => void;
    descriptionText: (text: string) => void;
  };
  list: {
    isDrivenSelect: string[];
    damageDegreeSelect: string[];
    otherPartSelect: string[];
  };
  error: {
    noticeDateText: string;
    descriptionText: string;
  };
  pickerInfo: {
    pickerSelect: string;
    pickerInputID: string;
    pickerContainerID: string;
  };
}
export const EntryCarConditionField = ({
  state: {
    isDrivenSelect: isDrivenSelectState,
    damageMapCheck: damageMapCheckState,
    damageDegreeSelect: damageDegreeSelectState,
    otherPartSelect: otherPartySelectState,
    noticeDateText: noticeDateTextState,
    descriptionText: descriptionTextState,
  },
  setState: {
    isDrivenSelect: setIsDrivenSelect,
    damageMapCheck: setDamageMapCheck,
    damageDegreeSelect: setDamageDegreeSelect,
    otherPartSelect: setOtherPartySelect,
    descriptionText: setDescriptionText,
  },
  list: {
    isDrivenSelect: isDrivenList,
    damageDegreeSelect: damageDegreeList,
    otherPartSelect: otherPartyList,
  },
  error: { descriptionText: descriptionError },
  pickerInfo: { pickerSelect, pickerInputID, pickerContainerID },
}: EntryCarConditionField) => {
  return (
    <div className={'entry-car-condition-field'}>
      <EntryField label={'自走できますか？'} required={true}>
        <RadioGroup
          groupName={'car_driven'}
          list={isDrivenList}
          value={isDrivenSelectState}
          onChange={setIsDrivenSelect}
        />
      </EntryField>
      <EntryField label={'整備する項目を選択してください'} required={true}>
        <DamageCheckMap map={damageMapCheckState} setMap={setDamageMapCheck} />
      </EntryField>
      <EntryField label={'損傷の程度はどのくらいですか？'} required={true}>
        <RadioGroup
          groupName={'damage_degree'}
          list={damageDegreeList}
          value={damageDegreeSelectState}
          onChange={setDamageDegreeSelect}
        />
      </EntryField>
      <EntryField label={'相手方がいる事故ですか？'} required={true}>
        <RadioGroup
          groupName={'other_party'}
          list={otherPartyList}
          value={otherPartySelectState}
          onChange={setOtherPartySelect}
        />
      </EntryField>
      <EntryField label={'お気づきになられたのはいつですか？'} required={true}>
        <ListItemPicker
          pickerSelect={pickerSelect}
          pickerInputID={pickerInputID}
          pickerContainerID={pickerContainerID}
        />
      </EntryField>
      <EntryField label={'損傷の詳細をご記入ください'} required={true}>
        <TextAreaField
          value={descriptionTextState}
          onChange={setDescriptionText}
          pattern={descriptionError}
          placeholder={
            '例：前側バンパーの右の方を擦ってしまった。駐車場にて左前ドアを凹まされた。'
          }
        />
      </EntryField>
    </div>
  );
};
